import React, { FC } from 'react'
import Card from 'components/Card'
import BaseImage, { BaseImageComponent } from 'components/Image'
import styled from 'styled-components'
import PrototypeCardDropdown from './PrototypeCardDropdown'
import { cardDropdownWrapperStyle } from 'components/Dropdown'
import Link from 'components/Link'
import { ReactComponent as PlayIcon } from 'icons/play-12.svg'
import { truncateStyles } from 'components/Truncate'
import LoadingPlaceholder from 'components/LoadingPlaceholder'

const StyledLink = styled(Link)`
  ${cardDropdownWrapperStyle};

  display: block;
  height: 100%;
`

const StyledCard = styled(Card)`
  width: 100%;
  max-width: 100%;
  height: 100%;

  position: relative;
`

const PrototypeCardBody = styled(Card.Body)`
  padding: 16px 20px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  width: 100%;
`

const PrototypeCardTitle = styled.span`
  ${truncateStyles};
  margin: 0;
  margin-right: 16px;
  font-size: 0.8125rem;
  max-width: calc(100% - 1rem);
  width: 100%;
  display: inline-block;
  color: ${({ theme }) => theme.colors.text.dark.base};
`

const ImageComponent = styled(BaseImageComponent)`
  object-fit: cover;
  object-position: top;
  width: 100%;
  height: 100%;
  /* stylelint-disable font-family-no-missing-generic-family-keyword */
  font-family: 'object-fit: cover;';
`

const Image = styled(BaseImage)`
  max-width: 100%;
  background-color: white;
  height: calc(100% - 52px);
  box-shadow: ${({ theme }) => theme.shadows.boxShadow.subtle};
`

const Play = styled(PlayIcon)`
  width: 12px;
  height: 12px;
  color: ${({ theme }) => theme.colors.gray};
`

export interface PrototypeCardProps {
  title: string
  src: string
  pathname: string
}

const PrototypeCard: FC<PrototypeCardProps> = ({
  title,
  src,
  pathname,
  ...props
}) => {
  return (
    <StyledLink
      to={{
        pathname,
        state: { fromOverview: true },
      }}>
      <StyledCard interactive {...props}>
        <Image
          alt={title}
          customImageElement={ImageComponent}
          src={src}
          loadingPlaceholder={<LoadingPlaceholder size="64px" />}
        />
        <PrototypeCardBody>
          <PrototypeCardTitle>{title}</PrototypeCardTitle>
          <Play />
        </PrototypeCardBody>
      </StyledCard>
      <PrototypeCardDropdown pathname={pathname} />
    </StyledLink>
  )
}

export default PrototypeCard
